{{ confirmationText }}
<ng-container *ngIf="!!helpCenterConfirmationLink">
  <yc-button
    [icon]="true"
    [tooltipText]="'common:textOpenHelpCenter' | ycI18n: 'Open help center'"
    [fontAwesomeIcon]="'arrow-up-right-from-square'"
    (onClick)="openHelpCenter()">
  </yc-button>
</ng-container>


<div class="block-wrapper">

  <yc-nonprofit-block-display
    [name]="selectedOrg.name"
    [nameIsLink]="false"
    [openNameInNewTab]="false"
    [nameRouterLink]="'/management/nonprofit/' + selectedOrg.document.id + '/profile'"
    [npoId]="selectedOrg.document.id"
    [addressString]="selectedOrg.address"
    [ein]="selectedOrg.registrationId"
    [eligibleForGivingStatusId]="selectedOrg.eligibleForGivingStatusId"
    [isPrivateOrg]="selectedOrg.isPrivateOrg"
    [img]="{
      iconURL: selectedOrg.iconURL,
      classification: selectedOrg.classification
    } | getOrgIcon">
  </yc-nonprofit-block-display>

  <div *ngIf="showContactForm"
    [formGroup]="nonprofitContactGroup">
    <div class="d-flex mt-4">
      <div class="add-org-input left-side">
        <yc-input
          [label]="'common:labelOrganizationContactFullName' | ycI18n:'Organization contact full name'"
          name="contactFullName"
          (onChange)="updateVettingContact('contactFullName', $event)">
        </yc-input>
      </div>
      <div class="add-org-input">
        <yc-input
          [label]="'common:labelOrgContactEmail' | ycI18n:'Organization contact email'"
          name="contactEmail"
          (onChange)="updateVettingContact('contactEmail', $event)">
        </yc-input>
      </div>
    </div>
    <div class="mb-4">
      <div>
        <yc-input
          [label]="'common:labelOrgContactWebsite' | ycI18n:'Organization website'"
          name="contactWebsite"
          (onChange)="updateVettingContact('contactWebsite', $event)">
        </yc-input>
      </div>
    </div>
  </div>
</div>